<script setup lang="ts">
// The preset layouts as small pictures to pick one (a multiview's, and a
// monitor wall's: the same presets, config.MultiviewLayouts).
import { type Rect } from '../api'
import { rectStyle } from '../util'

defineProps<{ layouts: { name: string; tiles: Rect[] }[]; layout: string }>()
const emit = defineEmits<{ pick: [name: string] }>()
</script>

<template>
    <div class="flex flex-wrap gap-1.5" data-test="layout-picker">
        <button
            v-for="l in layouts"
            :key="l.name"
            type="button"
            class="relative h-9 w-16 rounded border p-0"
            :class="l.name === layout ? 'border-accent' : 'border-line'"
            :title="`${l.name} (${l.tiles.length} tiles)`"
            :aria-label="`layout ${l.name}, ${l.tiles.length} tiles`"
            :aria-pressed="l.name === layout"
            @click="emit('pick', l.name)"
        >
            <span
                v-for="(r, i) in l.tiles"
                :key="i"
                class="absolute border border-bg-1 bg-bg-3"
                :class="{ 'bg-accent/40': l.name === layout }"
                :style="rectStyle(r)"
            />
        </button>
    </div>
</template>
